









import Vue from 'vue'
import Component from "vue-class-component"
import Product from "@/components/products/Product.vue"
import LayoutPublicProducts from "@/layouts/LayoutPublicProducts.vue"
import { Prop } from "vue-property-decorator"

@Component({
  components: {
    Product,
    LayoutPublicProducts
  }
})

export default class ProductView extends Vue {
  @Prop() publicUrl!: string
  @Prop() productId!: number

}
